import React, { Component } from 'react';
import { Card } from 'antd';
import { inject, observer } from 'mobx-react';
import moment from 'moment-timezone';

@inject('store')
@observer
export class RecentTrades extends Component {
    render() {
        const { trades } = this.props.store.odysseyBotStore;
        const timezone = this.props.store.userStore.currentUser.timezone;

        return (
            <Card
                title={'Recent Trades'}
                style={{ height: 250, overflow: 'hidden', overflowY: 'auto' }}
                bodyStyle={{ overflowY: 'auto', fontSize: '0.9em' }}
                bordered={false}
            >
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th />
                            <th>Price</th>
                            <th>Qty</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {trades.map((trade, i) => {
                            return (
                                <tr key={i}>
                                    <td>{this.renderTick(trade.tick_direction, trade.side)}</td>
                                    <td>
                                        <span
                                            className={trade.side === 'Buy' ? 'success' : 'error'}
                                        >
                                            {trade.price}
                                        </span>
                                    </td>
                                    <td>
                                        {trade.size.toLocaleString(undefined, {
                                            maximumFractionDigits: 2
                                        })}
                                    </td>
                                    <td>
                                        {moment(trade.timestamp)
                                            .tz(timezone)
                                            .format('h:mm:ss')}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </Card>
        );
    }

    renderTick(direction, side) {
        const cssClass = side === 'Buy' ? 'success' : 'error';

        if (direction === 'PlusTick') {
            return <i className={`fal fa-arrow-up ${cssClass}`} />;
        }
        if (direction === 'MinusTick') {
            return <i className={`fal fa-arrow-down ${cssClass}`} />;
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/TradeView/RecentTrades.js